import { getLanguageCodeFromPath, prependEditionHostname } from '../utils/url.mjs';

const withLeadingSlash = (url) => (url.startsWith('/') ? url : `/${url}`);

const isFromCurrentEdition = (currentEdition, fromPath) => {
  const fromLanguageCode = getLanguageCodeFromPath(fromPath);
  return fromLanguageCode === currentEdition;
};

// eslint-disable-next-line consistent-return -- optional return filtered out later
const transformTarget = (currentEdition, toUrl) => {
  // Keep absolute URLs as is
  if (URL.canParse(toUrl)) {
    return toUrl;
  }
  const normalizedToUrl = withLeadingSlash(toUrl);
  const toLanguageCode = getLanguageCodeFromPath(normalizedToUrl);
  // Return links relative to current edition as is
  if (toLanguageCode === currentEdition) {
    return normalizedToUrl;
  }
  if (toLanguageCode !== '') {
    return prependEditionHostname(toLanguageCode, normalizedToUrl);
  }
};

const transformRedirects = (currentEdition, redirects) => {
  const transformedRedirects = {};
  for (const [fromPath, toUrl] of Object.entries(redirects)) {
    const normalizedFromPath = withLeadingSlash(fromPath);
    if (isFromCurrentEdition(currentEdition, normalizedFromPath)) {
      const mappedTo = transformTarget(currentEdition, toUrl);
      if (mappedTo) {
        transformedRedirects[normalizedFromPath] = mappedTo;
      }
    }
  }
  return transformedRedirects;
};

// eslint-disable-next-line default-param-last -- Redux API
const redirectReducer = (state = [], action) => {
  switch (action.type) {
    case 'RECEIVE_SITE_OPTIONS':
      return action.payload.redirect
        ? transformRedirects(action.payload.currentEdition, action.payload.redirect)
        : state;
    default:
      return state;
  }
};

export { redirectReducer };
